export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_01.bec66b49.jpg";